<template>
    <v-container>
        <table align="center" width="100%" bgcolor="#E0E0E0">
            <tbody>
            <tr>
                <td>
                    <b>Paciente:</b>
                    {{this.$store.state.patient.firstLastName}} {{this.$store.state.patient.firstName}}
                </td>
                <td>
                    <b>Edad:</b>
                </td>
                <td>{{this.$store.state.patient.age}}</td>
                <td>
                    <b>Sexo:</b>
                </td>
                <td>{{this.$store.state.patient.gender}}</td>
                <td>
                    <b>No. HC:</b>
                </td>
                <td>{{this.$store.state.patient.identification}}</td>
            </tr>
            </tbody>
        </table>

        <v-tabs dark
                slider-color="yellow" show-arrows
                v-model="active">
            <v-tab class="no-print">
                Datos Paciente
            </v-tab>
            <v-tab-item>
                <PatientData></PatientData>
            </v-tab-item>
            <v-tab class="no-print" @click="$refs.formRuta!=null?$refs.formRuta.reload():'';($refs.formAnam ? $refs.formAnam.reloadData(): '')">
                ANAMNESIS
            </v-tab>
            <v-tab-item lazy>
                <Anamnesis ref="formAnam"></Anamnesis>
            </v-tab-item>
            <v-tab class="no-print" @click="$refs.formRuta!=null?$refs.formRuta.reload():''">
                EVOLUCIÓN
            </v-tab>
            <v-tab-item lazy>
                <Evolution></Evolution>
            </v-tab-item>
            <v-tab class="no-print">
                AUDIO
            </v-tab>
            <v-tab-item lazy>
                <Audio></Audio>
            </v-tab-item>
            <v-tab class="no-print">
                EMERGENCIA
            </v-tab>
            <v-tab-item lazy>
                <Emergencia></Emergencia>
            </v-tab-item>
            <v-tab class="no-print">
                OFTALMO
            </v-tab>
            <v-tab-item lazy>
                <Oftalmo></Oftalmo>
            </v-tab-item>
            <v-tab class="no-print">
                ANEXO DE SALUD Y TRABAJO
            </v-tab>
            <v-tab-item lazy>
                <anexo-salud-trabajo></anexo-salud-trabajo>
            </v-tab-item>
            <v-tab class="no-print">
                CONDICIÓN DE TRABAJO
            </v-tab>
            <v-tab-item lazy>
                <condicion-trabajo></condicion-trabajo>
            </v-tab-item>
            <v-tab class="no-print">
                VACUNAS
            </v-tab>
            <v-tab-item lazy>
                <patient-vaccine></patient-vaccine>
            </v-tab-item>
            <v-tab class="no-print" @click="$refs.formRuta!=null?$refs.formRuta.reload():''">
                ANEXOS
            </v-tab>
            <v-tab-item lazy>
                <anexos></anexos>
            </v-tab-item>
            <v-tab class="no-print">
                PROGRAMA DE MONITOREO
            </v-tab>
            <v-tab-item lazy>
                <carousel></carousel>
            </v-tab-item>
            <v-tab class="no-print" @click="$refs.formRuta!=null?$refs.formRuta.reload():''">
                RUTA
            </v-tab>
            <v-tab-item lazy>
                <ruta ref="formRuta"></ruta>
            </v-tab-item>
            <v-tab class="no-print" @click="$refs.formFpe!=null?$refs.formFpe.reload():''">
                FPE
            </v-tab>
            <v-tab-item lazy>
                <fpe ref="formFpe"></fpe>
            </v-tab-item>
        </v-tabs>
    </v-container>
</template>
<script>

    import AnexoSaludTrabajo from '../anexoSaludTrabajo/AnexoSaludTrabajo'
    import Carousel from "../monitoreo/Carousel";
    import Anamnesis from "../anamnesis/Anamnesis";
    import PatientData from "../patientData/PatientData";
    import Anexos from "../anexos/Anexos";
    import Evolution from "../evolucion/Evolucion";
    import Audio from "../audio/Audio";
    import CondicionTrabajo from "../condicionTrabajo/CondicionTrabajo";
    import Emergencia from "../emergencia/Emergencia";
    import Oftalmo from "../oftalmo/Oftalmo";
    import Fpe from "../fpe/Fpe";
    import Ruta from "../ruta/Ruta";
    import PatientVaccine from "../vaccine/PatientVaccine";

    export default {
        components: {
            Anamnesis,
            PatientData,
            AnexoSaludTrabajo,
            Carousel,
            Anexos,
            Evolution,
            Audio,
            CondicionTrabajo,
            Emergencia,
            Oftalmo,
            Fpe,
            Ruta,
            PatientVaccine
        },
        data() {
            return {
                active: 0,

            };
        }, methods: {},
        computed: {},
        beforeCreate() {
            this.$store.dispatch('getCompanies').then(response => {
            })
            this.$store.dispatch('getProcedures').then(response => {
            })
        },
        created() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patient/process/Process.vue